import { render, staticRenderFns } from "./dropdown-wrapper.vue?vue&type=template&id=312fef83&"
import script from "./dropdown-wrapper.vue?vue&type=script&lang=js&"
export * from "./dropdown-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('312fef83')) {
      api.createRecord('312fef83', component.options)
    } else {
      api.reload('312fef83', component.options)
    }
    module.hot.accept("./dropdown-wrapper.vue?vue&type=template&id=312fef83&", function () {
      api.rerender('312fef83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wrapper/dropdown-wrapper.vue"
export default component.exports